import Svg from 'components/utilities/svg'

const DonutChartIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Donut Chart Icon</title>
    <path d="M11,21.9 C8.43333333,21.65 6.29166667,20.575 4.575,18.675 C2.85833333,16.775 2,14.5333333 2,11.95 C2,9.36666667 2.85833333,7.125 4.575,5.225 C6.29166667,3.325 8.43333333,2.25 11,2 L11,5 C9.26666667,5.23333333 7.83333333,6.00833333 6.7,7.325 C5.56666667,8.64166667 5,10.1833333 5,11.95 C5,13.7166667 5.56666667,15.2583333 6.7,16.575 C7.83333333,17.8916667 9.26666667,18.6666667 11,18.9 L11,21.9 Z M13,21.9 L13,18.9 C14.5666667,18.7 15.8916667,18.05 16.975,16.95 C18.0583333,15.85 18.7166667,14.5166667 18.95,12.95 L21.95,12.95 C21.7166667,15.3333333 20.7625,17.3625 19.0875,19.0375 C17.4125,20.7125 15.3833333,21.6666667 13,21.9 Z M18.95,10.95 C18.7166667,9.38333333 18.0583333,8.05 16.975,6.95 C15.8916667,5.85 14.5666667,5.2 13,5 L13,2 C15.3833333,2.23333333 17.4125,3.1875 19.0875,4.8625 C20.7625,6.5375 21.7166667,8.56666667 21.95,10.95 L18.95,10.95 Z" />
  </Svg>
)

DonutChartIcon.displayName = 'DonutChart'

export default DonutChartIcon
